<template>
  <div>
    <a-row>
      <a-col :span="24">
        <center>
          <a-avatar :size="100" style="font-size:20px !important;background: #B4ABDC">U</a-avatar>
          <span class="avatar--action">
            <a-icon type="camera"/>
          </span>
        </center>
      </a-col>

      <a-col class="mt-4 pl-2" :span="24">
        <a-row>
          <a-col :span="24">
            <span class="text-bold">BASIC INFORMATION</span>
          </a-col>
        </a-row>
        <a-row class="mt-2">
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Full Name</small>
            <p>{{user.first_name}} {{user.last_name}}</p>
          </a-col>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Email</small>
            <p>{{user.email ? user.email : 'Not Available'}}</p>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Contact Phone</small>
            <p>{{user.phone_number ? user.phone_number : 'Not Available'}}</p>
          </a-col>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Username</small>
            <p>@{{user.username}}</p>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Fax</small>
            <p>{{user.fax ? user.name : 'Not Available'}}</p>
          </a-col>
        </a-row>
      </a-col>

      <!-- Location -->
      <a-col class="mt-4 pl-2" :span="24">
        <a-row>
          <a-col :span="24">
            <span class="text-bold">LOCATION INFORMATION</span>
          </a-col>
        </a-row>
        <a-row class="mt-2">
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Country</small>
            <p>{{user.country_d ? user.country_d.name : 'Not Available'}}</p>
          </a-col>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">State</small>
            <p>{{user.state_d ? user.state_d.name : 'Not Available'}}</p>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">City</small>
            <p>{{user.city_d ? user.city_d.name : 'Not Available'}}</p>
          </a-col>
          <a-col class="font-x2" :span="12">
            <small class="text-opacity">Zip Code</small>
            <p>{{user.zip_postal_code}}</p>
          </a-col>
          <a-col class="font-x2" :span="24">
            <small class="text-opacity">Address</small>
            <p>{{user.street_address}}</p>
          </a-col>
        </a-row>
      </a-col>

      <!-- Roles and Permissions -->
      <a-col class="mt-4 pl-2" :span="24">
        <a-row>
          <a-col :span="24">
            <span class="text-bold">ROLES</span>

            <div class="mt-2">
              <a-tag v-if="user && user.role">{{user.role.name}}</a-tag>
              <span v-else> No Role is assigned to user! </span>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<style scoped>
</style>

<script>
const columns = [
  {
    title: "Services",
    dataIndex: "name",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "Roles",
    className: "column-money",
    dataIndex: "money"
  }
];
const roles = [
  {
    key: "1",
    name: "Billing Service",
    money: "Super Admin, Client Manager",
    address: "New York No. 1 Lake Park"
  },
  {
    key: "2",
    name: "Payroll",
    money: "Client Relationship Manager",
    address: "London No. 1 Lake Park"
  },
  {
    key: "3",
    name: "Time Tracking",
    money: "Project Manager",
    address: "Sidney No. 1 Lake Park"
  }
];
export default {
  data() {
    return {
      roles,
      columns
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    }
  }
};
</script>
